module.exports = __webpack_public_path__ + "img/zlxg.df8e5873.png";